import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"
import type { AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    allow403?: boolean;
};

export const getBalanceDetails = (amount: string) => {
    return axiosPrivate.post('/bills/api/v1/balance-top-up/', { amount }, { allow403: true } as CustomAxiosRequestConfig);
}